"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickableCell = void 0;
var React = require("react");
var ClickableCell_style_1 = require("./ClickableCell.style");
var ClickableCell = function (props) {
    return (React.createElement(ClickableCell_style_1.CellValue, { onClick: function () { return props.HandleCellClick(props.data); } }, props.value));
};
exports.ClickableCell = ClickableCell;
